<template>
  <LayoutDefault>
    Материалы
  </LayoutDefault>
</template>

<script>
import LayoutDefault from '@/layout/LayoutDefault'

export default {
  name: 'MaterialsEditorView',
  components: {
    LayoutDefault
  },
  props: {
  },
  setup () {
  }
}
</script>

<style lang="scss" scoped>

</style>
